import { useEffect, useRef, useState } from "react";
import { fetchProductByHandle } from "../lib/storefront";
import type { PocaConfig, ProductDetailData } from "../types";

type State = {
  product: ProductDetailData | null;
  loading: boolean;
  error: string | null;
};

export function useProductDetail(config: PocaConfig, handle: string | null) {
  const [state, setState] = useState<State>({
    product: null,
    loading: handle != null,
    error: null,
  });
  const abortRef = useRef<AbortController | null>(null);

  useEffect(() => {
    if (!handle) {
      setState({ product: null, loading: false, error: null });
      return;
    }

    abortRef.current?.abort();
    const ac = new AbortController();
    abortRef.current = ac;

    setState({ product: null, loading: true, error: null });

    fetchProductByHandle(config, handle, ac.signal)
      .then((product) => {
        if (ac.signal.aborted) return;
        setState({ product, loading: false, error: null });
      })
      .catch((e) => {
        if (ac.signal.aborted) return;
        setState({
          product: null,
          loading: false,
          error: e instanceof Error ? e.message : "Failed to load product",
        });
      });

    return () => ac.abort();
  }, [config, handle]);

  return state;
}
